/**
 * Entidad que representa un indicador de riesgo
 */
export interface RiskIndicator {
  nombre: string;
  bajo: number;
  medio: number;
  alto: number;
}

/**
 * Entidad que representa el nombre de los indicadores de riesgo
 */
export type RiskIndicatorName =
  | 'nota'
  | 'asistencia'
  | 'beneficio'
  | 'social'
  | 'otro';

/**
 * Tipos de riesgo
 */
export const typesOfRisk: RiskIndicatorName[] = [
  'nota',
  'asistencia',
  'beneficio',
  'social',
  'otro',
];
